module.exports = __webpack_public_path__ + "img/icon_8.5b56e2c6.svg";